<template>
    <div>
        <div class="card">
            <div class="card-header">            
                <div class="row">
                    <div class="col">
                        <div class="card-header-title">
                            <span class="mdi mdi-wrench-outline text-muted mr-1"></span> Repairs
                        </div>
                    </div>
                    <div class="col">
                        <button class="btn btn-primary btn-sm float-right" @click="showCreateRepairModal">
                            Add Repair
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="alert alert-light repair-item" v-for="repair in repairs" :key="repair.repair_id">
                    <p class="mb-0">{{ repair.content }}</p>
                    <hr class="mt-2 mb-2">

                    <button class="btn btn-outline-secondary btn-sm mr-2" @click=showEditRepairModal(repair)>
                        <span class="mdi mdi-file-document-edit-outline" style="color: inherit;"></span> Edit
                    </button>
                    <button class="btn btn-outline-danger btn-sm" @click=confirmDeleteRepair(repair)>
                        <span class="mdi  mdi-trash-can-outline" style="color: inherit;"></span> Delete
                    </button>
                </div>

                <div class="text-center" v-if="repairs.length == 0">
                    <span class="mdi mdi-wrench-outline text-muted" style="font-size: 3em; opacity: 0.5;"></span>
                    <h5 class="text-muted mb-3">No Repairs added to this section</h5>
                    <button class="btn btn-primary" @click="showCreateRepairModal">Add Repair</button>
                </div>
            </div>
        </div>
      
        <!-- Edit repair modal -->
        <b-modal id="modal-edit-repair"            
            ok-title="Save"
            :title="isCreatingRepair ? 'Add Repair' : 'Edit Repair'"
            :ok-disabled="!editingRepairContent"
            @ok="onEditRepairOK">
            <div class="form-group">
                <label>Repair Content</label>
                <textarea class="form-control" rows="10" v-model="editingRepairContent" style="resize: none;"></textarea>
            </div>
        </b-modal>
        <!-- /Edit repair modal -->
        
    </div>
</template>

<script>
    import ReportService from '../../services/reports/reportService'

    export default {
        props: {
            sectionNumber: String,
            repairsProp: Array
        },
        data() {
            return {
                repairs: this.repairsProp,
                editingRepairContent: null,
                editingRepairId: null,
                isCreatingRepair: false
            }
        },
        methods: {
            showEditRepairModal(repair) {
                this.editingRepairId = repair.repair_id
                this.editingRepairContent = repair.content
                this.isCreatingRepair = false
                this.$bvModal.show('modal-edit-repair')
            },
            showCreateRepairModal() {
                this.isCreatingRepair = true
                this.editingRepairContent = ''
                this.$bvModal.show('modal-edit-repair')
            },
            confirmDeleteRepair(repair) {
                let msg = `Are you sure you wish to delete this repair? (This cannot be undone)`
                this.$bvModal
                    .msgBoxConfirm(msg, { centered: true })
                    .then(async (confirm) => {
                        if (confirm) {
                            await ReportService.deleteRepair(
                                this.$route.params.jobReference,
                                this.sectionNumber,
                                repair.repair_id)

                            let arrIndex = this.$_.findIndex(this.repairs, (r) => {
                                return r.repair_id == repair.repair_id
                            })
                            this.$delete(this.repairs, arrIndex)
                            this.$bvToast.toast('Repair deleted', {
                                title: 'Success',
                                variant: 'success',
                                solid: true,
                                appendToast: true,
                                autoHideDelay: 3000
                            })
                        }
                    }).catch((err) => {
                        console.error(err)
                        this.$bvToast.toast('Sorry, something went wrong and we couldn\'t delete the repair', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true,
                            appendToast: true,
                            autoHideDelay: 3000
                        })
                    })
            },
            async onEditRepairOK(evt) {
                evt.preventDefault()
                try {
                    if (this.isCreatingRepair) {
                        let createResult = await ReportService.createRepair(
                            this.$route.params.jobReference,
                            this.sectionNumber,
                            this.editingRepairContent)
                        
                        this.repairs.push(createResult)
                    }
                    else {
                        await ReportService.updateRepair(
                            this.$route.params.jobReference, 
                            this.sectionNumber, 
                            this.editingRepairId, 
                            this.editingRepairContent)

                        let arrIndex = this.$_.findIndex(this.repairs, (r) => {
                            return r.repair_id == this.editingRepairId
                        })
                        this.repairs[arrIndex].content = this.editingRepairContent
                    }                    

                    this.$bvModal.hide('modal-edit-repair')
                    this.editingRepairContent = null
                    this.editingRepairId = null

                    this.$bvToast.toast(`Repair saved`, {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                } catch (err) {
                    console.error(err)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t save your repair', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            }
        }
    }
</script>

<style lang="scss">
    .repair-item {
        border-left: 6px solid purple !important;
        border-top: 1px solid purple !important;
        border-right: 1px solid purple !important;
        border-bottom: 1px solid purple !important;        

        p {
            white-space: pre-wrap;
        }
    }    
</style>